import { useState } from 'react'
import { CreateUserFormData } from '../../types'
import { Separator } from '@/ui/separator'
import { Input } from '@/ui/input'
import { Label } from '@/ui/label'
import { Button } from '@/ui/button'
import { MaterialIcon } from '@/ui/material-icon'
import styles from './CreateUser.module.scss';

interface CreateUserFormProps {
  formData: CreateUserFormData
  expanded: boolean
  onFieldChange: <K extends keyof CreateUserFormData>(field: K, value: string) => void
  onCancel: () => void
  onSubmit: () => void
}

export default function CreateUserForm({
  formData,
  expanded,
  onFieldChange,
  onCancel,
  onSubmit,
}: CreateUserFormProps) {
  const [confirmPassword, setConfirmPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const handleSubmit = () => {
    if (formData.password !== confirmPassword) {
      setPasswordError('Passwords do not match')
      return
    }
    setPasswordError('')
    onSubmit()
  }

  return (
    <>
      <Separator />
      <h1 className={styles.title}>Add User</h1>
      <Separator />
      {expanded && (
        <div className={styles.cardBody}>
          {/* Email / Mobile */}
          <div className={styles.formField}>
            <Label className={styles.fieldLabel}>Email</Label>
            <Input
              type="text"
              value={formData.emailOrMobile}
              onChange={e => onFieldChange('emailOrMobile', e.target.value)}
              placeholder="Value"
              className={styles.fieldInput}
            />
          </div>

          {/* Password */}
          <div className={styles.formField}>
            <Label className={styles.fieldLabel}>Password</Label>
            <div className={styles.passwordInputWrap}>
              <Input
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={e => onFieldChange('password', e.target.value)}
                placeholder="Enter Password"
                className={`${styles.fieldInput} ${styles.fieldInputWithToggle}`}
              />
              <button
                type="button"
                className={styles.passwordToggleBtn}
                onClick={() => setShowPassword((prev) => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                <MaterialIcon name={showPassword ? 'visibility_off' : 'visibility'} size={18} />
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div className={styles.formField}>
            <Label className={styles.fieldLabel}>Confirm Password</Label>
            <div className={styles.passwordInputWrap}>
              <Input
                type={showConfirmPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                className={`${styles.fieldInput} ${styles.fieldInputWithToggle}`}
              />
              <button
                type="button"
                className={styles.passwordToggleBtn}
                onClick={() => setShowConfirmPassword((prev) => !prev)}
                aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
              >
                <MaterialIcon name={showConfirmPassword ? 'visibility_off' : 'visibility'} size={18} />
              </button>
            </div>
            {passwordError && <span className={styles.errorText}>{passwordError}</span>}
          </div>

          {/* Actions inside card */}
          <div className={styles.formActions}>
            <Button
  variant="outline"
  className={styles.cnloutlineCustom}
  onClick={onCancel}
>
  Cancel
</Button>
            <Button onClick={handleSubmit}>
              Add user
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
